document.addEventListener("turbo:load", () => {
  console.log("Load: recaptach_load.js");

  const recaptcha_token = document.getElementById("recaptcha_token");
  if (!recaptcha_token){
    return;
  }

  if (!document.querySelector("#recaptcha-script")) {
    const siteKey = document.querySelector('meta[name="recaptcha-site-key"]').content;
    const script = document.createElement("script");
    script.id = "recaptcha-script";
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
});